<template>
  <v-row class="pagination">
    <v-col
      cols="12"
      md="8"
      lg="4"
      offset-lg="4"
      class="pagination__col pagination__col--center"
    >
      <v-pagination
        :value="pagination.page"
        color="primary"
        :length="pagination.pageCount"
        :total-visible="5"
        :disabled="isLoading"
        @input="changePage"
      />
    </v-col>

    <v-col
      cols="12"
      md="4"
      lg="4"
      class="pagination__col"
    >
      <div
        v-if="!hidePageOptions"
        class="pagination__settings"
      >
        Pozycji na stronę
        <v-select
          :value="itemsPerPage"
          :items="itemsPerPageOptions"
          solo
          dense
          hide-details
          class="pagination__select"
          @change="changeItemsNumber"
        />
        {{ itemsShown }} of {{ pagination.itemsLength }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  props: {
    hidePageOptions: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      itemsPerPageOptions: [12, 24, 36],
    };
  },

  computed: {
    itemsShown() {
      const { itemsLength, page, pageCount } = this.pagination;
      const from = (page - 1) * this.itemsPerPage + 1;
      const to = page === pageCount ? itemsLength : page * this.itemsPerPage;
      return `${from}-${to}`;
    },

    ...mapState('pagination', [
      'pagination',
      'itemsPerPage',
    ]),

    ...mapState([
      'isLoading',
    ]),
  },

  methods: {
    ...mapActions('pagination', [
      'setPage',
      'setItemsPerPage',
    ]),

    changePage(pageNo) {
      this.setPage(pageNo)
        .then(() => {
          this.$emit('change');
        });
    },

    changeItemsNumber(itemsCount) {
      this.setItemsPerPage(itemsCount)
        .then(() => {
          this.$emit('change');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .pagination {
    margin-top: 8px;
    &__settings {
      font-size: 10px;
      display: inline-flex;
      align-items: center;
    }
    &__select {
      max-width: 80px;
      margin-left: 24px;
      margin-right: 16px;
      margin-bottom: 0;
    }
    &__col {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }
    &__col--center {
      justify-content: center;
    }
  }
</style>
